import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {TableComponent} from './table/table.component';
import {CdkTableModule} from '@angular/cdk/table';
import {TranslateModule} from '@ngx-translate/core';
import {MatButtonModule} from '@angular/material/button';
import {MatIconModule} from '@angular/material/icon';
import {MatMenuModule} from '@angular/material/menu';
import {MatPaginatorModule} from '@angular/material/paginator';
import {MatSortModule} from '@angular/material/sort';
import {ValgSortDirective} from './table/valg-sort.directive';
import {MatSelectModule} from '@angular/material/select';
import {ReactiveFormsModule} from '@angular/forms';
import {MatDialogModule} from '@angular/material/dialog';
import {MatInputModule} from '@angular/material/input';
import {DragDropModule} from '@angular/cdk/drag-drop';
import {ValgPaginatorModule} from "@valg-shared/components/table/table/valg-paginator/valg-paginator.module";
import {ValgSortHeaderModule} from "@valg-shared/components/table/table/valg-sort-header/valg-sort-header.module";
import {DataExportModule} from "@valg-shared/components/table/data-export/data-export.module";
import {ValgInputModule} from '@valg-shared/components/input/input.module';
import {TooltipModule} from '@valg-shared/components/tooltip/tooltip.module';
import {TextEllipsisTooltipRendererModule} from './renderers/text-ellipsis-tooltip-renderer/text-ellipsis-tooltip-renderer.module';
import {OverlayModule} from '@angular/cdk/overlay';
import {OverflowMenuModule} from '../overflow-menu/overflow-menu.module';
import {A11yModule} from '@angular/cdk/a11y';
import { BooleanRendererModule } from './renderers/boolean-renderer/boolean-renderer.module';
import { TableRowOptionsModule } from './table/table-row-options/table-row-options.module';
import { CellComponentOutletModule } from './directives/cell-component-outlet/cell-component-outlet.module';
import { NumberFormatWithDotRendererModule } from './renderers/number-format-with-dot-renderer/number-format-with-dot-renderer.module';

@NgModule({
  declarations: [
    TableComponent,
    ValgSortDirective
  ],
  exports: [ TableComponent, ValgSortDirective ],
  imports: [
    CommonModule,
    CdkTableModule,
    DragDropModule,
    TranslateModule,
    MatButtonModule,
    MatIconModule,
    MatMenuModule,
    MatPaginatorModule,
    MatSortModule,
    MatSelectModule,
    ReactiveFormsModule,
    MatDialogModule,
    MatInputModule,
    ValgPaginatorModule,
    TableRowOptionsModule,
    ValgSortHeaderModule,
    DataExportModule,
    ValgInputModule,
    TextEllipsisTooltipRendererModule,
    BooleanRendererModule,
    NumberFormatWithDotRendererModule,
    TooltipModule,
    OverlayModule,
    OverflowMenuModule,
    A11yModule,
    CellComponentOutletModule
  ],
})
export class TableModule {}
